export { ProgressBarComponent } from './lib/progress-bar.component';
